import React, { Component } from 'react';
import { connect } from 'react-redux';
import { initialize } from 'redux-form';
import { normalize, schema } from 'normalizr';
import { loadWorkshopPayments, exportWorkshopPayments } from './actions';
import Filter from './Filter';
import List from './List';
import authUtils from '../../auth/utils';
import { withTranslation } from 'react-i18next';
import SendMessageButton from '../../common/components/message/SendMessageButton';
import {
	sendMessage,
	PARENT_SEND_MESSAGE_REQUEST, PARENT_SEND_MESSAGE_SUCCESS, PARENT_SEND_MESSAGE_FAILURE
} from '../parents/actions';

class WorkshopPayments extends Component {
	constructor(props) {
		super(props);
		this.handleFilterSubmit = this.handleFilterSubmit.bind(this);
		this.handleFilterReset = this.handleFilterReset.bind(this);
		this.handleListEvent = this.handleListEvent.bind(this);
		this.handleListSelectionChange = this.handleListSelectionChange.bind(this);
		this.handleSendMessage = this.handleSendMessage.bind(this);
		this.state = {
			selectedEntities: []
		}
	}

	componentDidMount() {
		const { sortKey, sortDirection, pageNumber, pageSize } = this.props.pagination;

		let filter;
		if (this.props.parentId > 0) {
			filter = { parentId: this.props.parentId };
		} else {
			filter = { ...(this.props.pagination.filter || {}), parentId: null };
		}

		this.loadData({ filter, sortKey, sortDirection, pageNumber, pageSize });
		this.props.initializeFilter(filter);
	}

	loadData({ filter, sortKey, sortDirection, pageNumber, pageSize }) {
		this.props.loadEntities({ ...filter, sortKey, sortDirection, pageSize, pageNumber });
	}

	handleFilterSubmit(filter, exportFormat) {
		const { sortKey, sortDirection, pageSize } = this.props.pagination;
		this.setState({ selectedEntities: [] });
		this.loadData({ filter, sortKey, sortDirection, pageNumber: 1, pageSize });
		if (exportFormat) {
			this.exportData(filter, exportFormat);
		}
	}

	exportData(filter, exportFormat) {
		this.props.exportEntities(exportFormat, filter);
	}

	handleFilterReset() {
		this.handleFilterSubmit();
	}

	handleListEvent(listPagination) {
		const { filter } = this.props.pagination;
		this.loadData({ filter, ...listPagination });
	}

	handleListSelectionChange(newSelectedEntities) {
		this.setState({ selectedEntities: newSelectedEntities });
	}

	handleSendMessage(values, onSuccess) {
		const { sendMessage } = this.props;
		sendMessage({ ...values, parentIds: this.selectedParentIds() }, onSuccess);
	}

	selectedParentIds() {
		return [...new Set(this.state.selectedEntities.map(item => item.parent.id))]
	}

	normalizeData(payments) {
		const parent = new schema.Entity('parents', {}, {
			idAttribute: c => c.id
		});
		const payment = new schema.Entity('woprshopPayments', { parent: parent }, {
			idAttribute: p => p.id
		});
		const normalizedData = normalize(payments, [payment]);
		return normalizedData;
	}

	renderListActions() {
		const { canSendMessage } = this.props;

		const normalizedData = this.normalizeData(this.state.selectedEntities);
		const parents = normalizedData && normalizedData.entities && normalizedData.entities.parents;

		return <React.Fragment>
			{canSendMessage && <SendMessageButton onSendMessage={this.handleSendMessage} to={parents && Object.values(parents).map(p => ({ name: p.fullname, email: p.email }))}
				block={PARENT_SEND_MESSAGE_REQUEST} unblock={[PARENT_SEND_MESSAGE_SUCCESS, PARENT_SEND_MESSAGE_FAILURE]} />}
		</React.Fragment>
	}

	render() {
		const { isReadonly, paymentTypes, paymentStatusTypes, paymentMethods, canSendMessage, parentId } = this.props;
		return (
			<div>
				{!parentId && <Filter initialValues={{ workshops: [] }} onSubmit={this.handleFilterSubmit} onReset={this.handleFilterReset} paymentTypes={paymentTypes}
					paymentStatusTypes={paymentStatusTypes} paymentMethods={paymentMethods} loading={this.props.pagination.loading || this.props.export.loading} />}
				<List isReadonly={isReadonly} onFetchData={this.handleListEvent} data={this.props.data} {...this.props.pagination}
					selectedEntities={this.state.selectedEntities} onSelectionChange={this.handleListSelectionChange}
					listActions={!parentId && this.renderListActions()} canSendMessage={canSendMessage} parentId={parentId}
				/>
			</div>
		);
	}
}

const mapStateToProps = (state, ownProps) => {
	const parentId = ownProps.parentId;
	const {
		pagination,
		exports,
		entities: { workshopPayments },
		lookups: { paymentTypes, paymentStatusTypes, paymentMethods },
		auth: { currentUser },
		configuration: { franchisor }
	} = state;

	const workshopPaymentsPagination = (parentId ? pagination.workshopPayments[`parent-${parentId}`] : pagination.workshopPayments.all) || { ids: [], pageNumber: 1, pageSize: 10 };
	const workshopPaymentsExport = parentId ? {} : exports.workshopPayments.all || {};

	return {
		data: workshopPaymentsPagination.ids.map(id => workshopPayments[id]),
		parentId,
		pagination: workshopPaymentsPagination,
		export: workshopPaymentsExport,
		isReadonly: authUtils.hasReadOnlyPermission(currentUser, 'WoprshopPayments'),
		paymentTypes: paymentTypes,
		paymentStatusTypes: paymentStatusTypes,
		paymentMethods: paymentMethods,
		canSendMessage: franchisor.enableAdHocMessages && authUtils.hasPermission(currentUser, 'SendMessage')
	};
};

export default connect(mapStateToProps, {
	loadEntities: loadWorkshopPayments,
	exportEntities: exportWorkshopPayments,
	sendMessage,
	initializeFilter: (data, fields) => initialize('workshopPaymentsFilter', data, fields)
})(withTranslation()(WorkshopPayments));